import { render } from "./Footer-Layout.vue?vue&type=template&id=9b10a946"
import script from "./Footer-Layout.vue?vue&type=script&lang=js"
export * from "./Footer-Layout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__